var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 167.472,
    height: 60.836,
    viewBox: "0 0 167.472 60.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,5.822c3.384,2.213,4.363,3.866,10.669,6.769s12.608.27,17.82-.819C34.6,10.5,36.364,6.638,30.337,8.345s-11.219.359-13.13-.706-5.545-2.757.539-1.681S25.4,4.551,22.027,4.051,16.383,1.076,10.074.1C5.028-.69,1.156,3.568,0,5.822Z",
    transform: "translate(1.131 34.423)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.1,36.964l-2.968,3.28c-.5-.829-1-2.485-1.113-5.8C-.089,31.227.23,15.982.271,8.761A1.033,1.033,0,0,1,.89,7.814C1.509,7.578,26.352-.179,26.73,0c.735.354,21.016,5.8,25.963,7.811.493.2.743.593.743,2.012.008.593-.153,7.855-.145,8.522-.123,3.1-.2,20.707-.48,21.185-1.182,2.012-1.443,5.688-11.86,13.492C34,58.231,28.505,60.364,26.859,60.836c-8.677-3.555-15.723-8.858-20.3-12.311l7.792,2.428c11.128,5.837,10.133,5.265,12.358,6.094,14.216-6.037,20.3-14.672,22.153-17.514.456-.7.7-13.995.858-16.926L49.6,10.535C42.228,8.443,27.325,4.357,26.733,4.262S11.4,8.364,4.108,10.535l0,0Z",
    transform: "translate(0 0)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,.69H6.644A6.575,6.575,0,0,1,8.423.921a3.505,3.505,0,0,1,1.454.756,3.537,3.537,0,0,1,.977,1.513,7.045,7.045,0,0,1,.368,2.481A6.667,6.667,0,0,1,11.005,7.5a3.757,3.757,0,0,1-.585,1.24,2.966,2.966,0,0,1-.8.777A5.374,5.374,0,0,1,8.683,10l3,6.242H8.4L5.818,10.482H5.21c-.217-.015-.442-.021-.673-.021H3.843c-.231,0-.442-.007-.63-.021v5.8H0Z",
    transform: "translate(59.277 19.704)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M7.446,9.171a2.709,2.709,0,0,0,.781-.105,1.48,1.48,0,0,0,.608-.357,1.717,1.717,0,0,0,.391-.715,3.562,3.562,0,0,0,.151-1.135,3.209,3.209,0,0,0-.151-1.072,1.4,1.4,0,0,0-.391-.672,1.3,1.3,0,0,0-.608-.336,2.709,2.709,0,0,0-.781-.105H4.582v4.5H7.446Z",
    transform: "translate(57.911 18.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M19.089,2.74V.679a.4.4,0,0,1,.456-.441h2.475a.379.379,0,0,1,.3.126.47.47,0,0,1,.109.315V2.74a.368.368,0,0,1-.413.42H19.544C19.24,3.16,19.089,3.019,19.089,2.74Z",
    transform: "translate(53.583 19.839)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M19.18,6.771h3.213V18.057H19.18Z",
    transform: "translate(53.556 17.89)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M30.132,18.094q-.628-.02-1.26-.084c-.42-.041-.81-.092-1.173-.147a6.822,6.822,0,0,1-.911-.231V15.8h5.167a3.437,3.437,0,0,0,.738-.064.737.737,0,0,0,.434-.274.994.994,0,0,0,.151-.589v-.357A.791.791,0,0,0,33,13.87a1.711,1.711,0,0,0-1.043-.231H30.131a5.2,5.2,0,0,1-1.8-.295,2.649,2.649,0,0,1-1.281-.967,3.172,3.172,0,0,1-.456-1.807V9.92a3.5,3.5,0,0,1,.434-1.807A2.7,2.7,0,0,1,28.48,7a8.325,8.325,0,0,1,2.8-.379A14.58,14.58,0,0,1,32.8,6.7q.825.062,1.541.189a6.779,6.779,0,0,1,1.173.252V8.973H30.629a1.772,1.772,0,0,0-.955.21.777.777,0,0,0-.326.736v.336a.9.9,0,0,0,.151.567.921.921,0,0,0,.456.252,4.357,4.357,0,0,0,.8.064h1.867a3.553,3.553,0,0,1,2.583.8,2.83,2.83,0,0,1,.825,2.165v1.009a2.722,2.722,0,0,1-.564,1.807,3.094,3.094,0,0,1-1.607.946,10.258,10.258,0,0,1-2.562.274h0C30.943,18.136,30.553,18.121,30.132,18.094Z",
    transform: "translate(51.345 17.936)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M42.894,0h3.213V8.659h1.368L50.038,4.75h3.256l-3.43,5.318,3.777,5.969H50.385l-2.952-4.56H46.109v4.56H42.894Z",
    transform: "translate(46.482 19.91)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-9",
    "data-name": "Vector",
    d: "M68.215.69h6.642a6.575,6.575,0,0,1,1.779.231A3.36,3.36,0,0,1,79.068,3.19a7.045,7.045,0,0,1,.368,2.481A6.667,6.667,0,0,1,79.219,7.5a3.727,3.727,0,0,1-.585,1.24,2.988,2.988,0,0,1-.8.777A5.373,5.373,0,0,1,76.9,10l3,6.242H76.616l-2.584-5.759h-.608c-.217-.015-.442-.021-.673-.021h-.694c-.232,0-.442-.007-.63-.021v5.8H68.215Z",
    transform: "translate(38.929 19.704)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-10",
    "data-name": "Vector",
    d: "M75.66,9.169a2.709,2.709,0,0,0,.781-.105,1.48,1.48,0,0,0,.608-.357,1.717,1.717,0,0,0,.391-.715,3.562,3.562,0,0,0,.151-1.135,3.209,3.209,0,0,0-.151-1.072,1.4,1.4,0,0,0-.391-.672,1.3,1.3,0,0,0-.608-.336,2.717,2.717,0,0,0-.781-.105H72.8v4.5H75.66Z",
    transform: "translate(37.562 18.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-11",
    "data-name": "Vector",
    d: "M88.77,17.6A3.141,3.141,0,0,1,87.1,15.838a9.756,9.756,0,0,1-.5-3.489A10.6,10.6,0,0,1,87.076,8.8a3,3,0,0,1,1.607-1.766,7.642,7.642,0,0,1,3.06-.5,9.348,9.348,0,0,1,2.779.336,2.487,2.487,0,0,1,1.5,1.177,4.867,4.867,0,0,1,.477,2.376,3.068,3.068,0,0,1-.477,1.807,2.57,2.57,0,0,1-1.3.946,6.526,6.526,0,0,1-2,.274H89.791a4.3,4.3,0,0,0,.26,1.387,1.457,1.457,0,0,0,.847.736,5.949,5.949,0,0,0,1.8.21h3.407V17.6q-.846.169-1.867.336a16.72,16.72,0,0,1-2.388.147l0,0A8.088,8.088,0,0,1,88.77,17.6Z",
    transform: "translate(33.444 17.963)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-12",
    "data-name": "Vector",
    d: "M93.732,12.549a1.491,1.491,0,0,0,.955-.252,1.123,1.123,0,0,0,.3-.9,2.023,2.023,0,0,0-.2-.967,1.058,1.058,0,0,0-.608-.525,2.983,2.983,0,0,0-1.107-.169,2.344,2.344,0,0,0-1.173.252,1.364,1.364,0,0,0-.63.841,5.925,5.925,0,0,0-.2,1.723h2.649Z",
    transform: "translate(32.107 17.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-13",
    "data-name": "Vector",
    d: "M103.823,17.361a2.708,2.708,0,0,1-.826-2.1V14.25a2.67,2.67,0,0,1,.934-2.1,4.25,4.25,0,0,1,2.909-.841h2.973v-.777a1.7,1.7,0,0,0-.2-.861,1.116,1.116,0,0,0-.738-.5A5.615,5.615,0,0,0,107.273,9h-3.495V7.188a15.517,15.517,0,0,1,4.667-.631,7.99,7.99,0,0,1,2.475.336,2.788,2.788,0,0,1,1.562,1.156,4.075,4.075,0,0,1,.543,2.27v7.671h-2.539l-.521-1.2a2.169,2.169,0,0,1-.521.379,8.942,8.942,0,0,1-.911.441,7.387,7.387,0,0,1-1.194.357,6.214,6.214,0,0,1-1.368.147h0A3.056,3.056,0,0,1,103.823,17.361Z",
    transform: "translate(28.552 17.954)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-14",
    "data-name": "Vector",
    d: "M109.443,18.556l.564-.126c.2-.056.384-.105.543-.147q.261-.084.413-.147c.116-.041.188-.07.217-.084V15.426l-1.954.126a2.136,2.136,0,0,0-1.26.42,1.249,1.249,0,0,0-.391.967V17.4a1.271,1.271,0,0,0,.174.694,1.141,1.141,0,0,0,.5.4,2.337,2.337,0,0,0,.717.105h0A3.16,3.16,0,0,0,109.443,18.556Z",
    transform: "translate(27.187 15.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-15",
    "data-name": "Vector",
    d: "M122.092,15.615a3.491,3.491,0,0,1-1.411-1.807,9.893,9.893,0,0,1-.456-3.3,12.337,12.337,0,0,1,.391-3.4,3.364,3.364,0,0,1,1.368-1.912,4.849,4.849,0,0,1,2.626-.61,7.5,7.5,0,0,1,1.585.169,9.923,9.923,0,0,1,1.39.357V0h3.235V16.037h-2.713l-.521-1.072a4.088,4.088,0,0,1-.911.61,5.894,5.894,0,0,1-1.107.441,4.819,4.819,0,0,1-1.173.147h0A4.489,4.489,0,0,1,122.092,15.615Z",
    transform: "translate(23.413 19.91)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-16",
    "data-name": "Vector",
    d: "M128.06,16.389a5.712,5.712,0,0,0,.89-.42V10.294c-.289-.1-.593-.2-.911-.295a3.459,3.459,0,0,0-1.02-.147,2.708,2.708,0,0,0-1.3.274,1.629,1.629,0,0,0-.694,1.03,8.008,8.008,0,0,0-.217,2.143,8.323,8.323,0,0,0,.2,2.038,1.642,1.642,0,0,0,.673.987,2.352,2.352,0,0,0,1.215.274h0A3.1,3.1,0,0,0,128.06,16.389Z",
    transform: "translate(22.047 16.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-17",
    "data-name": "Vector",
    d: "M143.247,18.054a3.893,3.893,0,0,1-1.715-.357,3.392,3.392,0,0,1-1.237-1.009,5.106,5.106,0,0,1-.738-1.661l-2.192-8.26h3.343l1.845,7.63a1.841,1.841,0,0,0,.283.631,1.165,1.165,0,0,0,.368.336,2.735,2.735,0,0,0,.347.126,2.2,2.2,0,0,0,.26.021l2.105-8.743h3.256L145.7,20.954l-1.043,2.081h-2.669Z",
    transform: "translate(18.3 17.892)",
    fill: "#1a1d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-18",
    "data-name": "Vector",
    d: "M6.424,0V6.4H0V0Z",
    transform: "translate(19.59 25.048)",
    fill: "#0086e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-19",
    "data-name": "Vector",
    d: "M6.424,0V6.4H0V0Z",
    transform: "translate(27.472 25.048)",
    fill: "#0086e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-20",
    "data-name": "Vector",
    d: "M6.424,0V6.4H0V0Z",
    transform: "translate(19.59 17.495)",
    fill: "#0086e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-21",
    "data-name": "Vector",
    d: "M6.424,0V6.4H0V0Z",
    transform: "translate(27.472 17.495)",
    fill: "#0086e6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a8fb4c02f9066ac6340efdfce24a8bb1.svg";
export { ForwardRef as ReactComponent };